module.exports = __webpack_public_path__ + "img/a557bcf.png";